var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9C0 4.02944 4.02944 0 9 0H26V17C26 21.9706 21.9706 26 17 26H0V9Z",
    fill: "#FFAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4355 10.7261V14.4033C11.621 14.1856 11.0323 13.4437 11.0323 12.5647C11.0242 11.6857 11.621 10.9438 12.4355 10.7261Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.2987V11.0166C6.84673 11.0811 7.51605 11.7908 7.51605 12.6617C7.52411 13.5245 6.8548 14.2342 6 14.2987Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1127 12.5562C10.1127 13.9432 11.1207 15.1044 12.4352 15.3383V17.5559C12.4352 17.9753 12.0965 18.314 11.6771 18.314H7.85474C6.83059 18.314 6 17.4834 6 16.4592V15.2173C7.35477 15.1528 8.43536 14.0238 8.43536 12.661C8.43536 11.2901 7.35477 10.1692 6 10.0966V8.85475C6 7.8306 6.83059 7 7.85474 7H11.6771C12.0965 7 12.4352 7.33869 12.4352 7.75803V9.78212C11.1126 10.016 10.1127 11.1691 10.1127 12.5562Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5723 14.3637V10.7671C14.3142 11.0251 14.8464 11.7348 14.8464 12.5654C14.8464 13.396 14.3061 14.0976 13.5723 14.3637Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 11.2744V14.0404C19.2337 14.0404 18.6128 13.4195 18.6128 12.6614C18.6128 11.8954 19.2337 11.2744 19.9998 11.2744Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 8.85475V10.3547C19.0244 10.3547 18.1292 10.9595 17.8228 11.8869C17.2986 13.4755 18.476 14.9512 20.0001 14.9512V16.4511C20.0001 17.4753 19.1695 18.3059 18.1454 18.3059H14.323C13.9036 18.3059 13.5649 17.9672 13.5649 17.5479V15.3141C14.8229 15.0238 15.7584 13.9029 15.7584 12.5562C15.7584 11.2095 14.8229 10.0886 13.5649 9.80631V7.75803C13.5649 7.33869 13.9036 7 14.323 7H18.1454C19.1695 7 20.0001 7.8306 20.0001 8.85475Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampIcon);
export default __webpack_public_path__ + "static/media/camp_icon.15cb6d348ccf82bcd390b43801b038cd.svg";
export { ForwardRef as ReactComponent };